type Options = {
  debugMode: boolean;
  newApiUrl: string;
  surveyApiUrl: string;
  invoiceApiUrl: string;
  autobundlerUrl: string;
  algoUrl: string;
  googleMapsApiKey: string;
  pusherKey: string;
  firebaseKey: string;
  googleAnalyticsCode: string;
  sentryDSN: string;
  sentryEnvironment: string;
  sentryRelease: string;
  environment: string;
  assetsBaseURL: string;
  datadog?: {
    logs: {
      token: string;
    };
    rum?: {
      applicationId: string;
      clientToken: string;
      sampleRate: number; // Overall sample
      replaySampleRate: number; // Percentage of the samples above with replays
    };
    env: string;
    service: 'dispatch';
  };
};
const prodOptions: Options = {
  algoUrl: 'https://awsbundler.porterbuddy.com',
  autobundlerUrl:
    'https://auto-router.apps-euw3.porterbuddy.production.ibx.dev',
  assetsBaseURL: 'https://porterbuddy-assets.s3-eu-west-1.amazonaws.com',
  debugMode: false,
  environment: 'production',
  firebaseKey: 'AIzaSyC0LWVYAzBK2uwCwFdGQNHzgy7kFYUvFdY',
  googleAnalyticsCode: 'UA-110136254-7',
  googleMapsApiKey: 'AIzaSyDJAGBkZ1qT_djNrqiuunA3KV7kJt5ZRi0',
  invoiceApiUrl: 'https://invoicing-api.porterbuddy.com/',
  newApiUrl: 'https://orca-dispatch.apps-euw3.porterbuddy.production.ibx.dev',
  pusherKey: 'a7c2733e46dd7af6933b',
  sentryDSN: '',
  sentryEnvironment: 'production',
  sentryRelease: '',
  surveyApiUrl: 'https://api.survey.porterbuddy.com',
  datadog: {
    logs: {
      token: 'pube9eae793c67196eb834a564f6ff867aa',
    },
    rum: {
      applicationId: '5d296d7a-0b48-42a6-8112-7f87a74f0571',
      clientToken: 'pub0e29f7cbe6ba5485967c5af4c79560e8',
      sampleRate: 50,
      replaySampleRate: 20,
    },
    env: 'prod',
    service: 'dispatch',
  },
};

const testOptions: Options = {
  algoUrl: 'https://awsbundler.porterbuddy.com',
  autobundlerUrl: 'https://auto-router.apps-euw3.porterbuddy.staging.ibx.dev',
  assetsBaseURL: 'https://porterbuddy-assets.s3-eu-west-1.amazonaws.com',
  debugMode: false,
  environment: 'test',
  firebaseKey: 'AIzaSyCBomPE274DRpnTKIUeK7XVn2DA1aiShQY',
  googleAnalyticsCode: '',
  googleMapsApiKey: 'AIzaSyDJAGBkZ1qT_djNrqiuunA3KV7kJt5ZRi0',
  invoiceApiUrl: 'https://invoicing-api.porterbuddy-test.com',
  newApiUrl: 'https://orca-dispatch.apps-euw3.porterbuddy.staging.ibx.dev',
  pusherKey: '769420788d951a1a6b71',
  sentryDSN: '',
  sentryEnvironment: 'test',
  sentryRelease: '',
  surveyApiUrl: 'https://api.survey.porterbuddy-test.com',
  datadog: {
    logs: {
      token: 'pube3ee762bff2e8eea9a91ed21344dba21',
    },
    rum: {
      applicationId: '5d296d7a-0b48-42a6-8112-7f87a74f0571',
      clientToken: 'pub0e29f7cbe6ba5485967c5af4c79560e8',
      sampleRate: 100,
      replaySampleRate: 0,
    },
    env: 'test',
    service: 'dispatch',
  },
};

const localOptions: Options = {
  algoUrl: process.env.REACT_APP_ALGO_URL,
  autobundlerUrl: process.env.REACT_APP_AUTOBUNDLER_URL,
  debugMode: true,
  environment: 'development',
  firebaseKey: process.env.REACT_APP_FIREBASE_KEY,
  googleAnalyticsCode: '',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  invoiceApiUrl: process.env.REACT_APP_INVOICE_API_URL,
  newApiUrl: process.env.REACT_APP_NEW_API_URL,
  pusherKey: process.env.REACT_APP_PUSHER_KEY,
  sentryDSN: '',
  sentryEnvironment: '',
  sentryRelease: '',
  surveyApiUrl: process.env.REACT_APP_SURVEY_API_URL,
  assetsBaseURL: process.env.REACT_APP_ASSETS_BASE_URL,
  datadog: {
    logs: {
      token: 'pube3ee762bff2e8eea9a91ed21344dba21',
    },
    // rum: {
    //   applicationId: '5d296d7a-0b48-42a6-8112-7f87a74f0571',
    //   clientToken: 'pub0e29f7cbe6ba5485967c5af4c79560e8',
    // },
    env: 'test',
    service: 'dispatch',
  },
};

let options = prodOptions;

const host = window.location.host;

if (
  host.includes('porterbuddy-test.com') ||
  host.includes('test.aws.porterbuddy.com') ||
  host.includes('.web.app') ||
  host.includes('porterbuddy.staging.ibx.dev')
) {
  options = testOptions;
}

if (host.includes('localhost')) {
  options = localOptions;
}

console.log(options.environment);
export const settings = {
  ...options,
};
